import Cookies from 'js-cookie'

const sessionName = 'TRIPLA_CLIENT_SESSION'
const rejectedSessionName = 'TRIPLA_REJECTED_CLIENT_SESSION'

export function setClientSession(session) {
  Cookies.set(sessionName, session, { expires: 18 / 24 })
}

export function getClientSession() {
  return Cookies.get(sessionName)
}

// Remember for this tab a session the server has refused, so the embedding
// page cannot hand the same dead one back (see requestParentClientSession).
// The cookie is left alone: CB reads the same cookie when it runs on the BW
// page, and keeps a refused session until its replacement is written.
export function rememberRejectedClientSession(session) {
  try {
    if (session) sessionStorage.setItem(rejectedSessionName, session)
  } catch (e) {
    // storage can be blocked in a third-party iframe
  }
}

// Remember and drop a refused session before a reload, so the reload doesn't
// reuse it and the embedding page can't loop the page with it.
export function rejectClientSession(session) {
  rememberRejectedClientSession(session)
  return Cookies.remove(sessionName)
}

// Whether rejectClientSession can survive a reload. Without it, borrowing from
// the parent is unsafe: a dead session it keeps handing back would reload forever.
export function canRememberRejectedClientSession() {
  try {
    const probe = `${rejectedSessionName}_PROBE`
    sessionStorage.setItem(probe, '1')
    sessionStorage.removeItem(probe)
    return true
  } catch (e) {
    return false
  }
}

export function getRejectedClientSession() {
  try {
    return sessionStorage.getItem(rejectedSessionName)
  } catch (e) {
    return null
  }
}
